import Basic from './Basic';
import Background from './Background';
import Avatar from './Avatar';
import Logo from './Logo';

export const Image = Basic;
export const BackgroundImage = Background;
export const AvatarImage = Avatar;
export const LogoImage = Logo;
